module.exports = __webpack_public_path__ + "00f35ffe79bc38912e4bf6e5a358b6eb.svg";